// extracted by mini-css-extract-plugin
export default {"row":"row__3EVC3","clientForm":"clientForm__dV8FZ"};
    if(module.hot) {
      // 1788784370619
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  